// extracted by mini-css-extract-plugin
export default {"modalContent":"EditorModal_modalContent__v29Jt","title":"EditorModal_title__OVnHX","content":"EditorModal_content__Ew-yb","buttons":"EditorModal_buttons__vP-W5"};